import { render, staticRenderFns } from "./product-showcase-conduit.vue?vue&type=template&id=4ba90482&scoped=true&"
import script from "./product-showcase-conduit.vue?vue&type=script&lang=js&"
export * from "./product-showcase-conduit.vue?vue&type=script&lang=js&"
import style0 from "./product-showcase-conduit.vue?vue&type=style&index=0&id=4ba90482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba90482",
  null
  
)

export default component.exports